module.exports = __webpack_public_path__ + "media/images/banner/saibashi/bannerv4-2067c623a37fa3af505629c26472559b.jpg";